<template>
  <v-dialog
    v-model="proxyValue"
    fullscreen
    hide-overlay
    persistent
    scrollable
  >
    <v-card tile>

      <!--  컨트롤러  -->
      <v-card-actions class="px-1">
        <v-btn
          @click="proxyValue = false"
          elevation="0"
          text
        >
          <v-icon x-large>mdi-chevron-left</v-icon>
          <span class="font-weight-bold">뒤로가기</span>
        </v-btn>
      </v-card-actions>

      <!--  구분선  -->
      <v-divider class="grey"/>

      <!--  본문  -->
      <div class="c-card-text pa-3 grey lighten-3" style="display: grid;">
        <div id="address-search-wrap"></div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommonAlertHtml",
  props: ['value'],
  watch: {
    async proxyValue(val) {
      if (!val) return

      let el = null
      while (!el) {
        el = document.querySelector('#address-search-wrap')
        if (!el) await new Promise(resolve => setTimeout(resolve))
      }

      const it = this

      // 참고: https://postcode.map.daum.net/guide
      new window.daum.Postcode({
        oncomplete: function (data) {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
          it.$store.state.gsSubmit_formData.refund_starting_address = data.roadAddress
          it.proxyValue = false
        },
        width : '100%',
        height : '100%'
      }).embed(el)
    }
  },
  computed: {
    proxyValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    onClick() {
      this.gmCommon_alertHtmlClose()
      if (this.$store.state.gsCommon_alertHtmlUseTerm) {
        this.$store.state.gsCommon_alertHtmlTermCheck = true
      }
    }
  }
}
</script>